import { CHANGE_PRIVACY_POLICY, CHANGE_RECAPCHA_STATUS } from './types';

export const changePrivacyPolicy = payload => {
    return { type: CHANGE_PRIVACY_POLICY, payload };
};

export const changeRecapcha = payload => {
    return { type: CHANGE_RECAPCHA_STATUS, payload };
};